import _ from 'lodash';
import React from 'react';
import { Grid, Margin, Media, Padding, Stack, Text } from '../../components';
import { BenefitsAndPerksData } from './shared';

const MappedBenefitsAndPerksComponent = (props) => {
  let { startingIndex, endingIndex, columns } = props;
  return (
    <section>
      <Grid columns={columns} space={8}>
        {_.flow(
          (BenefitsAndPerksData) =>
            _.map(BenefitsAndPerksData, (value, index) => {
              return <div key={index}>{value?.icon}</div>;
            }),
          (BenefitsAndPerksData) =>
            _.slice(BenefitsAndPerksData, startingIndex, endingIndex)
        )(BenefitsAndPerksData)}
      </Grid>
      <Grid columns={columns} space={8}>
        {_.flow(
          (BenefitsAndPerksData) =>
            _.map(BenefitsAndPerksData, (value, index) => {
              return (
                <Text align="left" textType="primary1" key={index}>
                  {value?.title}
                </Text>
              );
            }),
          (BenefitsAndPerksData) =>
            _.slice(BenefitsAndPerksData, startingIndex, endingIndex)
        )(BenefitsAndPerksData)}
      </Grid>
      <Grid columns={columns} space={8}>
        {_.flow(
          (BenefitsAndPerksData) =>
            _.map(BenefitsAndPerksData, (value, index) => {
              return (
                <Text align="left" textType="primary2" key={index}>
                  {value?.description}
                </Text>
              );
            }),
          (BenefitsAndPerksData) =>
            _.slice(BenefitsAndPerksData, startingIndex, endingIndex)
        )(BenefitsAndPerksData)}
      </Grid>
    </section>
  );
};

export const BenefitsAndPerksDesktop = () => {
  return (
    <>
      <Media at="lg">
        <Padding size={[7]} backgroundRole="grey2">
          <Stack size={4}>
            <Margin size={[0, 0, 4, 0]}>
              <Text align="left" textType="heading3">
                Benefits & Perks
              </Text>
            </Margin>
            <MappedBenefitsAndPerksComponent
              columns={5}
              startingIndex={0}
              endingIndex={5}
            />
          </Stack>
        </Padding>
      </Media>

      <Media at="xmd">
        <Padding size={[7]} backgroundRole="grey2">
          <Stack size={4}>
            <Margin size={[0, 0, 4, 0]}>
              <Text align="left" textType="heading3">
                Benefits & Perks
              </Text>
            </Margin>
            <Stack size={5}>
              <MappedBenefitsAndPerksComponent
                columns={3}
                startingIndex={0}
                endingIndex={3}
              />

              <Padding size={[0, 9]}>
                <MappedBenefitsAndPerksComponent
                  columns={2}
                  startingIndex={3}
                  endingIndex={5}
                />
              </Padding>
            </Stack>
          </Stack>
        </Padding>
      </Media>
    </>
  );
};
